"use client";
import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();

  // Mengambil data image_url dan email dari cookies
  const imageUrl = Cookies.get("image_url");
  const email = Cookies.get("email");

  return (
    <div className="profile-container p-6 h-full pt-20 pb-48 ml-[200px] max-sm:ml-[50px] items-center justify-center bg-gray-50 max-sm:mt-16">
      <div className="profile-header text-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-700">Profile</h2>
        <p className="text-sm text-gray-500">Welcome to your profile</p>
      </div>

      <div className="profile-details flex flex-col items-center space-y-4">
        <div className="profile-image">

          <img
            src={imageUrl || "/default-profile.png"}
            alt="Profile"
            className="rounded-full w-32 h-32 object-cover border-2 border-indigo-600"
          />
        </div>
        <div className="profile-info text-center">
          <h3 className="text-xl font-medium text-gray-800">Email:</h3>
          <p className="text-md text-gray-600">{email}</p>
        </div>
      </div>

      <div className="profile-actions mt-6 text-center">
        <button
          onClick={() => navigate("/dashboard/profile")}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition"
        >
          Change profile photo
        </button>
      </div>
    </div>
  );
}

export default Profile;
